import React, { useEffect, useState } from "react";
import NFTCards from "../../components/nftCards/NFTCards";
import Creators from "./Creators";
import * as nftActions from "../../store/actions/nftActions";
import { nftFeatureKey } from "../../store/featureKeys";
import { useSelector, useDispatch } from "react-redux";
// Stylesheet
import "./ExploreNFTs.css";
import firebase from "./../../firebase";

// Material UI
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import PreloaderInner from "./../../components/preloader/loader";
import { useLocation } from "react-router-dom";
import CreatorData from "./CreatorData";
function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function ExploreNFTs() {
  let dispatch = useDispatch();
  let query = useQuery().get("name");
  const [filterOptionType, setFilterOption] = React.useState("nft");
  const [nfts, setNFts] = useState();

  const nftData = useSelector((state) => state[nftFeatureKey]);

  useEffect(() => {
    console.log("nftData ==> ", nftData);
    if (nftData.loading) {
      setLoader(true);
    } else {
      setLoader(false);
    }
  }, [nftData]);
  useEffect(() => {
    console.log("query ==> ", query);
  }, [query]);
  const [loader, setLoader] = useState(true);
  const [value, setValue] = React.useState("mostpopular");
  const [creator, setCreatorList] = useState();

  useEffect(() => {
    setLoader(true);
    if (!nfts && query === null) {
      dispatch(nftActions.fetchNFTCollection("mostpopular"));
    }
  }, [query]);

  useEffect(async () => {
    if (filterOptionType !== "nft") {
      setLoader(true);
      await firebase
        .firestore()
        .collection("UserDataModel")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            setCreatorList((prev) => [...prev, doc.data()]);
          });
        });
      setLoader(false);
    } else {
      setCreatorList("");
      setLoader(false);
    }
  }, [filterOptionType]);

  const handleDropdown = (event) => {
    setFilterOption(event.target.value);
  };

  const handleTabs = (event, newValue) => {
    setValue(newValue);
    if (query === null) {
      dispatch(nftActions.fetchNFTCollection(newValue));
    } else {
      dispatch(nftActions.filterAndSearchInNFTCollection(newValue, query));
    }
  };
  let [showFilters, setShowFilters] = useState(false);

  return (
    <div className="explore-page">
      {loader && <PreloaderInner />}
      <h1 className="space-heading margin-heading">
        {query ? `${query}` : "EXPLORE"}
      </h1>
      <p className="yellow">
        {query
          ? `${nftData.nfts.length} NFTs Found`
          : "Check out the amazing collection of NFTs and find their creators"}
      </p>
      <div className="filter-tabs">
        <FormControl
          className="explore-dropdown hide-in-mobile"
          sx={{
            minWidth: 120,
            bgcolor: "white",
          }}
        >
          <Select
            value={filterOptionType}
            onChange={handleDropdown}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={"creator"}>Creators</MenuItem>
            <MenuItem value={"nft"}>NFT</MenuItem>
          </Select>
        </FormControl>
        <div className="handle-in-phone">
          <Box sx={{ bgcolor: "none" }} className="box">
            {filterOptionType === "nft" && (
              <Tabs
                value={value}
                onChange={handleTabs}
                centered
                className="tabs"
              >
                <Tab
                  value="all"
                  label="All"
                  // className={"tab" + (value === "all" ? " tabActive" : "")}
                />
                <Tab
                  value="mostpopular"
                  label="Most Popular"
                  // className={
                  //   "tab" + (value === "mostpopular" ? " tabActive" : "")
                  // }
                />
                <Tab
                  value="likes"
                  label="Most Liked"
                  // className={"tab" + (value === "likes" ? " tabActive" : "")}
                />
                <Tab
                  value="image"
                  label="Images"
                  // className={"tab" + (value === "image" ? " tabActive" : "")}
                />
                <Tab
                  value="video"
                  label="Video"
                  // className={"tab" + (value === "video" ? " tabActive" : "")}
                />
                <Tab
                  value="gif"
                  label="Gif"
                  // className={"tab" + (value === "gif" ? " tabActive" : "")}
                />
              </Tabs>
            )}
          </Box>
        </div>

        <button
          className="filters hide-in-mobile"
          onClick={(e) => {
            setShowFilters((prevState) => !prevState);
          }}
        >
          <FilterAltOutlinedIcon />
          <p>Filters</p>
        </button>
      </div>
      <div className="show-in-mobile filter-tabs">
        <FormControl
          className="explore-dropdown"
          sx={{
            minWidth: 120,
            bgcolor: "white",
          }}
        >
          <Select
            value={filterOptionType}
            onChange={handleDropdown}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
          >
            <MenuItem value={"creator"}>Creators</MenuItem>
            <MenuItem value={"nft"}>NFT</MenuItem>
          </Select>
        </FormControl>
        <button
          className="filters"
          onClick={(e) => {
            setShowFilters((prevState) => !prevState);
          }}
        >
          <FilterAltOutlinedIcon />
          <p>Filters</p>
        </button>
      </div>
      {showFilters && <CreatorData />}
      <section style={{ marginTop: "0vh" }}>
        {filterOptionType === "nft" ? (
          <NFTCards nfts={nftData.nfts} />
        ) : (
          <Creators creator={creator} />
        )}
      </section>
    </div>
  );
}

export default ExploreNFTs;
